<style lang="less">
    #empty {

    }
</style>
<template>
    <div id="empty">
        {{ msg }}
    </div>
</template>
<script>
    export default {
        name: "empty",
        props: [],
        components: {},
        data() {
            return {
                // msg: 'this is new page called 404 !',
            }
        },
        watch: {},
        computed: {},
        methods: {},
        mounted() {

        },
        created() {

        }
    }
</script>
